import React, { useState, useEffect } from 'react';
import { getFirestore, collection, addDoc, updateDoc, deleteDoc, doc, getDocs } from 'firebase/firestore';
import { TextField, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const db = getFirestore();

const TileManager = () => {
    const [tiles, setTiles] = useState([]);
    const [newTileName, setNewTileName] = useState('');
    const [newTileURL, setNewTileURL] = useState('');
    const [newTileDescription, setNewTileDescription] = useState('');
    const [editingTile, setEditingTile] = useState(null);
    const [editingTileData, setEditingTileData] = useState({ Name: '', url: '', Description: '' });
    const [openDialog, setOpenDialog] = useState(false);
    const [tileToDelete, setTileToDelete] = useState(null);

    useEffect(() => {
        const fetchTiles = async () => {
            const tilesCollection = collection(db, 'hvac/GenericData/tiles');
            const tilesSnapshot = await getDocs(tilesCollection);
            const tilesList = tilesSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            setTiles(tilesList);
        };

        fetchTiles();
    }, []);

    const addTile = async () => {
        if (newTileName.trim() === '' || newTileURL.trim() === '' || newTileDescription.trim() === '') return;
        const docRef = await addDoc(collection(db, 'hvac/GenericData/tiles'), {
            Name: newTileName,
            url: newTileURL,
            Description: newTileDescription
        });
        setTiles([...tiles, { id: docRef.id, Name: newTileName, url: newTileURL, Description: newTileDescription }]);
        setNewTileName('');
        setNewTileURL('');
        setNewTileDescription('');
    };

    const updateTile = async (id) => {
        const tileDoc = doc(db, 'hvac/GenericData/tiles', id);
        await updateDoc(tileDoc, editingTileData);
        setTiles(tiles.map(tile => (tile.id === id ? { ...tile, ...editingTileData } : tile)));
        setEditingTile(null);
    };

    const handleDeleteClick = (id) => {
        setTileToDelete(id);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setTileToDelete(null);
    };

    const confirmDeleteTile = async () => {
        if (tileToDelete) {
            const tileDoc = doc(db, 'hvac/GenericData/tiles', tileToDelete);
            await deleteDoc(tileDoc);
            setTiles(tiles.filter(tile => tile.id !== tileToDelete));
            handleCloseDialog();
        }
    };

    return (
        <div>
            <h2>Tile Manager</h2>
            <TextField
                label="New Tile Name"
                value={newTileName}
                onChange={(e) => setNewTileName(e.target.value)}
            />
            <TextField
                label="New Tile URL"
                value={newTileURL}
                onChange={(e) => setNewTileURL(e.target.value)}
            />
            <TextField
                label="New Tile Description"
                value={newTileDescription}
                onChange={(e) => setNewTileDescription(e.target.value)}
            />
            <Button variant="contained" onClick={addTile}>Add Tile</Button>
            <TableContainer component={Paper}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Name</TableCell>
                            <TableCell>URL</TableCell>
                            <TableCell>Description</TableCell>
                            <TableCell>Actions</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {tiles.map(tile => (
                            <TableRow key={tile.id}>
                                {editingTile === tile.id ? (
                                    <>
                                        <TableCell>
                                            <TextField
                                                label="Edit Name"
                                                value={editingTileData.Name}
                                                onChange={(e) => setEditingTileData({ ...editingTileData, Name: e.target.value })}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                label="Edit URL"
                                                value={editingTileData.url}
                                                onChange={(e) => setEditingTileData({ ...editingTileData, url: e.target.value })}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <TextField
                                                label="Edit Description"
                                                value={editingTileData.Description}
                                                onChange={(e) => setEditingTileData({ ...editingTileData, Description: e.target.value })}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Button variant="contained" onClick={() => updateTile(tile.id)}>Save</Button>
                                        </TableCell>
                                    </>
                                ) : (
                                    <>
                                        <TableCell>{tile.Name}</TableCell>
                                        <TableCell>{tile.url}</TableCell>
                                        <TableCell>{tile.Description}</TableCell>
                                        <TableCell>
                                            <IconButton onClick={() => {
                                                setEditingTile(tile.id);
                                                setEditingTileData({ Name: tile.Name, url: tile.url, Description: tile.Description });
                                            }}>
                                                <EditIcon />
                                            </IconButton>
                                            <IconButton onClick={() => handleDeleteClick(tile.id)}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </TableCell>
                                    </>
                                )}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Dialog
                open={openDialog}
                onClose={handleCloseDialog}
            >
                <DialogTitle>Confirm Deletion</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete this tile?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={confirmDeleteTile} color="primary" autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default TileManager; 